import React, { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingWrapper } from '../../../shared/components/LoadingWrapper';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import withErrorLog from '../../../shared/utils/withErrorLog';
import { displayLibxProductDetail } from '../../../store/header/actions';
import { useParams } from 'react-router';
import { useLibxProduct } from './api/useLibxProduct';
import { useAddLibxProductToCollection } from './api/useAddLibxProductToCollection';
import ProductDetailCover from '../../../shared/product/detail/ProductDetailCover';
import ProductDetailShortInfo from '../../../shared/product/detail/ProductDetailShortInfo';
import ProductDetailExtendedInfo from '../../../shared/product/detail/ProductDetailExtendedInfo';
import { LibxStatisticsWithStockDetails } from '../shared/LibxStatisticsWithStockDetails';
import { LibxProductDetailSidebar } from './LibxProductDetailSidebar';
import { LibxProductDetailProductGroups } from './LibxProductDetailProductGroups';
import ProductDetailLayout from '../../../shared/product/detail/ProductDetailLayout';
import ProductNotFound from '../../../shared/product/ProductNotFound';

const LibxProductDetailPage = () => {
    const dispatch = useDispatch();
    const { productId } = useParams<{ productId: string }>();
    const { data: product, isLoading } = useLibxProduct(productId);

    const { mutate } = useAddLibxProductToCollection();

    useLayoutEffect(() => {
        dispatch(displayLibxProductDetail());
    }, [dispatch]);

    if (isLoading) {
        return (
            <LoadingWrapper>
                <LoadingOverlay loading={isLoading} />
            </LoadingWrapper>
        );
    }

    if (!product?.isbn13) {
        return null;
    }

    if (!product) {
        return <ProductNotFound />;
    }

    const productDetailCover = <ProductDetailCover product={product} />;
    const productDetailShortInfo = <ProductDetailShortInfo product={product} isLibx={true} />;
    const productDetailExtendedInfo = <ProductDetailExtendedInfo product={product} isLibx={true} />;
    const productDetailStatistics = (
        <LibxStatisticsWithStockDetails
            activeLibraries={product?.activeLibraries}
            copyAmount={product?.copyAmount}
            stockDetails={product?.stockDetails}
            detailView={true}
        />
    );
    const productDetailSidebar = (
        <LibxProductDetailSidebar product={product} addToCollection={() => mutate(productId)} />
    );

    const embeddedEntryPageBottom = <LibxProductDetailProductGroups product={product} />;

    return (
        <ProductDetailLayout
            pageTitle={product?.title!}
            cover={productDetailCover}
            shortInfo={productDetailShortInfo}
            statistics={productDetailStatistics}
            extendedInfo={productDetailExtendedInfo}
            sidebar={productDetailSidebar}
            bottom={embeddedEntryPageBottom}
        />
    );
};

export default withErrorLog(LibxProductDetailPage);
